export default class SetUpTableRowsError extends Error {

}
